module.exports = __webpack_public_path__ + "img/VirtualCapabilities_00048.201c7c9d.jpg";